// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jev0","questions":"styles_questions__1UmqL","footer":"styles_footer__3DvVi"};